import { createContext } from "react";

export const ModeloDatosApp = {
    tokenApi: null
};

export const DatosAppContext = createContext(ModeloDatosApp);